import { Button, Image, Row, Col } from 'react-bootstrap';
import { convertStorage, getUnits } from './logic';
import { RenderIf, Break } from "@alanngo/custom-components/dist"
import cpu from "../../assets/icons/cpu.png"
import ram from "../../assets/icons/ram.png"
import nvme from "../../assets/icons/nvme.png"
import ssd from "../../assets/icons/ssd.png"
import hdd from "../../assets/icons/hdd.png"
import gpu from "../../assets/icons/gpu.png"
const Laptop = ({ laptop }) =>
(
    <>
        <Break />
        <h1>{laptop.name || ""} | ${laptop.price || ""}</h1>
        <Break />

        <Image src={laptop.links.image} fluid width={500} />
        <Break number={2} />
        <Row>
            <Col><Image src={cpu} fluid width={50} title="CPU"/></Col>
            <Col><h4 >{laptop.cpu}</h4></Col>
        </Row>
        <Row>
            <Col ><Image src={ram} fluid width={50} title="RAM"/></Col>
            <Col ><h4>{laptop.ram} GB</h4></Col>
        </Row>
        <RenderIf condition={laptop.storage.nvme}>
            <Row>
                <Col><Image src={nvme} fluid width={50} title="NVME SSD"/></Col>
                <Col>
                    <h4>{convertStorage(laptop.storage.nvme)} {getUnits(laptop.storage.nvme)}</h4>
                </Col>
            </Row>
        </RenderIf>
        <RenderIf condition={laptop.storage.ssd}>
            <Row>
                <Col><Image src={ssd} fluid width={50} title="SATA SSD"/></Col>
                <Col>
                    <h4>{convertStorage(laptop.storage.ssd)} {getUnits(laptop.storage.ssd)}</h4>
                </Col>
            </Row>
        </RenderIf>


        <RenderIf condition={laptop.storage.hdd}>
            <Row>
                <Col><Image src={hdd} fluid width={50} title="Hard Drive"/></Col>
                <Col>
                    <h4> {convertStorage(laptop.storage.hdd)} {getUnits(laptop.storage.hdd)} </h4>
                </Col>
            </Row>
        </RenderIf>
        <Row>
            <Col><Image src={gpu} fluid width={50} title="GPU"/></Col>

            <Col><h4>{laptop.gpu}</h4></Col>
        </Row>
        <Break />
        <Row>
            <Col>
                <RenderIf condition={laptop.links.newegg}>
                    <a href={laptop.links.newegg}><Button variant="info" disabled={!laptop.links.newegg}>Buy from Newegg</Button></a>
                </RenderIf>
            </Col>
            <Col>
                <RenderIf condition={laptop.links.amazon}>
                    <a href={laptop.links.amazon}><Button variant="warning" disabled={!laptop.links.amazon}>Buy from Amazon</Button></a>
                </RenderIf>
            </Col>
        </Row>
    </>
)

export default Laptop